<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div style="margin-top: 4%">
      <b-row align-v="center" align-h="end">
        <b-col cols="3">
          <b-form-group align="left">
            <label for="cuenta">Cuentas:</label>
            <v-select
              label="nombreCuenta"
              id="idCuenta"
              v-model="cuenta"
              :options="lstCuentas"
              :reduce="(variable) => variable.idCuenta"
              required
              multiple
            >
              <span slot="no-options">No hay datos...</span>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group align="left">
            <label for="grupos">Grupos:</label>
            <v-select
              label="nombreGrupo"
              id="grupos"
              v-model="grupos"
              :options="lstGrupos"
              :reduce="(variable) => variable.idGrupo"
              required
              multiple
            >
              <span slot="no-options">No hay datos...</span>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group align="left">
            <label for="plan"
              >Archivo:<em
                class="info_svg ml-1"
                @click="mostrarModal = !mostrarModal"
                v-b-tooltip.hover
                title="Información sobre la carga"
                style="width: 20%"
              ></em
            ></label>
            <b-form-file
              v-model="archivo"
              placeholder="Seleccionar archivo"
              browse-text="Abrir"
              type="file"
              @change="cargarArchivo($event)"
            ></b-form-file>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <a
            class="mt-1"
            v-if="cuenta != null || grupos.length > 0 || archivo != null"
            ><em
              class="trash"
              @click="limpiar()"
              v-b-tooltip.hover
              title="Limpiar filtros"
            ></em
          ></a>
        </b-col>
      </b-row>
    </div>

    <div style="margin-top: 5%;">
      <b-table
        :items="usuariosAux"
        :fields="fieldsCuenta"
        :per-page="registrosPorPagina"
        :current-page="paginaActual"
        responsive="true"
        fixed
      >
      </b-table>
      <b-pagination
        v-if="usuariosAux !== undefined && usuariosAux.length > 10"
        align="center"
        v-model="paginaActual"
        :total-rows="usuariosAux.length"
        :per-page="registrosPorPagina"
      ></b-pagination>
      <div v-if="usuariosAux.length === 0" class="d-flex justify-content-center align-items-center" style="min-height: 30vh">
        <p>No se encontraron resultados</p>
      </div>
      <b-button class="btn-guardar" v-if="usuariosAux.length > 0" variant="primary" @click="validar" :disabled="loader">
        <span v-if="!loader">Guardar</span>
        <span v-if="loader">
          <b-spinner small></b-spinner> Cargando...
        </span>
      </b-button>
    </div>

    <b-modal
      v-model="mostrarModal"
      title="Información de la Carga"
      size="lg"
      hide-footer
    >
      <b-form-text id="password-help-block">
        El archivo de carga de pacientes debe tener los siguientes datos en el
        orden establecido (La columna correspondiente esta entre parentesis):

        <ul>
          <li>(A) Nombre*</li>
          <li>(B) Apellido Paterno*</li>
          <li>(C) Apellido Materno*</li>
          <li>(D) Correo electronico*</li>
          <li>(E) Nombre Usuario*</li>
        </ul>

        <p><small> El archivo no debe tener ningun tipo de margen. </small></p>

        <a href="/files/Formato-usuario.xlsx" download> Descargar Formato</a>
      </b-form-text>
    </b-modal>

    <download-excel
      id="excel"
      :data="lstUsuariosDuplicados"
      :fields="{ USUARIOS: 'usuario' }"
      worksheet="usuarios"
      name="Usuarios duplicados.xls"
      style="display: none"
    >
    </download-excel>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  name: "altaMasivaUsuario",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loader: false,
      mostrarModal: false,
      paginaActual: 0,
      registrosPorPagina: 10,
      cuenta: null,
      lstCuentas: [],
      grupos: [],
      lstGrupos: [],
      fieldsCuenta: [
        { key: "nombre", label: "Nombre(s)", sortable: true },
        { key: "apellidoPaterno", label: "Apellido Paterno", sortable: true },
        { key: "apellidoMaterno", label: "Apellido Materno", sortable: true },
        { key: "correo", label: "Correo electronico", sortable: true },
        { key: "usuario", label: "Nombre usuario", sortable: true },
      ],
      archivo: null,
      usuarios: [],
      usuariosAux: [],
      lstUsuariosDuplicados: [],
      lstUsuariosFormato: [],
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerCuentas();
    this.catalogoGrupo();
  },
  methods: {
    cargarArchivo(e) {
      this.usuarios = [];
      this.usuariosAux = [];
      this.lstUsuariosFormato = [];
      const files = e.target.files;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        const data = ev.target.result;
        const workbook = XLSX.read(data, {
          type: "binary", // binary
        });
        const wsname = workbook.SheetNames[0]; //take the first sheet
        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //Get the data in this table

        this.lstUsuariosFormato = ws;
        this.lstUsuariosFormato.map((value) => {
          if (
            value["NOMBRE"] === undefined ||
            value["PATERNO"] === undefined ||
            value["MATERNO"] === undefined ||
            value["CORREO"] === undefined ||
            value["USUARIO"] === undefined
          ) {
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: "El formato no cumple con los campos básicos en uno registro",
            });
            return false;
          }

          const pat = {
            nombre: value["NOMBRE"].trimStart().trimEnd().toUpperCase(),
            apellidoPaterno: value["PATERNO"]
              .trimStart()
              .trimEnd()
              .toUpperCase(),
            apellidoMaterno: value["MATERNO"]
              .trimStart()
              .trimEnd()
              .toUpperCase(),
            correo: value["CORREO"].trimStart().trimEnd(),
            usuario: value["USUARIO"].trimStart().trimEnd().toUpperCase(),
          };
          this.usuariosAux.push(pat);
        });
      };

      fileReader.readAsBinaryString(files[0]);
    },
    validar() {
      if (this.cuenta === null || this.cuenta.length === 0) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Seleccione una cuenta",
        });
        return false;
      }

      if (this.grupos.length === 0) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Seleccione un grupo",
        });
        return false;
      }

      if (this.usuariosAux.length === 0) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "No hay usuarios",
        });
        return false;
      }

      this.$swal
        .fire({
          icon: "info",
          title: "Aviso",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCancelButton: true,
          showConfirmButton: true,
          allowOutsideClick: false,
          text: "¿Los datos de los usuarios son correctos?",
        })
        .then((aceptar) => {
          if (aceptar.value) {
            this.lstUsuariosFormato.map((value) => {
              let listaUsuarioDatos = [];
              const nombre = {
                idDatoUsuario: 3,
                valor: "Nombre",
                valorDato: value["NOMBRE"].trimStart().trimEnd().toUpperCase(),
              };
              listaUsuarioDatos.push(nombre);
              const apellidoPaterno = {
                idDatoUsuario: 1,
                valor: "Apellido Paterno",
                valorDato: value["PATERNO"].trimStart().trimEnd().toUpperCase(),
              };
              listaUsuarioDatos.push(apellidoPaterno);
              const apellidoMaterno = {
                idDatoUsuario: 2,
                valor: "Apellido Materno",
                valorDato: value["MATERNO"].trimStart().trimEnd().toUpperCase(),
              };
              listaUsuarioDatos.push(apellidoMaterno);
              const correoElectronico = {
                idDatoUsuario: 4,
                valor: "Correo Electronico",
                valorDato: value["CORREO"].trimStart().trimEnd(),
              };
              listaUsuarioDatos.push(correoElectronico);
              const nombreUsuario = {
                idDatoUsuario: 5,
                valor: "Nombre Usuario",
                valorDato: value["USUARIO"].trimStart().trimEnd().toUpperCase(),
              };
              listaUsuarioDatos.push(nombreUsuario);
              const contrasenia = {
                idDatoUsuario: 6,
                valor: "Contraseña",
                valorDato: "general",
              };
              listaUsuarioDatos.push(contrasenia);
              let a = { listaUsuarioDatos };
              a["idSistema"] = 6;
              a["idCanal"] = 28;
              a["idUsuarioNSD"] = null;
              a["cuentasSeleccionado"] = this.cuenta;
              a["gruposSeleccionados"] = this.grupos;
              this.usuarios.push(a);
            });

            this.guardar();
          }
        });
    },
    guardar() {
      this.loader = true;

      this.$http
        .post(
          this.$api + "admin/portalautoservicio/masivoGuardarPorSistema",
          this.usuarios
        )
        .then((respuesta) => {
          if (!respuesta.data.data.error) {
            this.$swal
              .fire({
                icon: "success",
                title: "Se guardo la carga correctamente",
                allowOutsideClick: false,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  if (respuesta.data.data.length != 0) {
                    this.$swal
                      .fire({
                        icon: "question",
                        confirmButtonText: "Si",
                        cancelButtonText: "No",
                        showCancelButton: true,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        title: "Aviso",
                        html: "<p>Se encontraron usuarios duplicados</p> <br> <strong><span>¿Desea generar Excel?</span></strong>",
                      })
                      .then((result) => {
                        if (result.isConfirmed) {
                          this.generarExcel(respuesta.data.data);
                        }
                      });
                  }
                  this.limpiar();
                }
              });
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Ocurrió un problema",
            text: "Por favor espere unos minutos y vuelva a intentar",
          });
          console.error(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    obtenerCuentas() {
      this.$http
        .get(this.$api + "portalautoservicio/catalogo/cuentas")
        .then((response) => {
          if (response.data.data) {
            this.lstCuentas = [];
            this.lstCuentas = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    limpiar() {
      this.cuenta = null;
      this.archivo = null;
      this.usuariosAux = [];
      this.usuarios = [];
      this.grupos = [];
    },
    generarExcel(datos) {
      datos.forEach((datos) => {
        datos.listaUsuarioDatos.forEach((value) => {
          if (value.idDatoUsuario == 5)
            this.lstUsuariosDuplicados.push({ usuario: value.valorDato });
        });
      });
      document.getElementById("excel").click();
      this.lstUsuariosDuplicados = [];
    },
    catalogoGrupo() {
      this.$http
        .post(this.$api + "portalautoservicio/catalogo/gruposPortal")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.lstGrupos = respuesta.data.data;
          }
        });
    },
  },
};
</script>

<style scoped>
.card-usuarios {
  border-radius: 25px;
  box-shadow: 3px 4px 7px 2px rgb(110 110 110 / 43%);
  margin: 1vw;
}

.btn-guardar {
  background-color: #1B81AF;
  border: 1px solid #1B81AF;
  margin-top: 4%;
}

.btn-guardar:hover{
  background-color: #49a9d6;
  border: 1px solid #49a9d6;
}
</style>
